var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDebtSmsEmail(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 221,
    height: 221,
    viewBox: "0 0 221 221",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SMS_Email_",
    "data-name": "SMS / Email ",
    transform: "translate(-17757 -13007)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_589",
    "data-name": "Ellipse 589",
    cx: 110.5,
    cy: 110.5,
    r: 110.5,
    transform: "translate(17757 13007)",
    fill: "#7dbaab"
  }), /*#__PURE__*/React.createElement("g", {
    id: "email",
    transform: "translate(17800.867 13028.031)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_19713",
    "data-name": "Path 19713",
    d: "M330.991,111.363l45.544,39.923a14.221,14.221,0,0,0,1.57-6.506V76.065a14.3,14.3,0,0,0-.423-3.45Z",
    transform: "translate(-244.839 -30.878)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_19714",
    "data-name": "Path 19714",
    d: "M47.126,111.306.427,72.552A14.286,14.286,0,0,0,0,76.019v68.715a14.226,14.226,0,0,0,1.57,6.506Z",
    transform: "translate(0 -30.831)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_19715",
    "data-name": "Path 19715",
    d: "M99.631,240.854l-3.717,3.085a15.2,15.2,0,0,1-19.409,0l-3.729-3.1-46.326,40.61a14.228,14.228,0,0,0,7.431,2.084h33.71a1.306,1.306,0,0,1,1.047.529l12.3,16.675a6.449,6.449,0,0,0,5.207,2.645h.031a6.449,6.449,0,0,0,5.2-2.6l12.578-16.732a1.308,1.308,0,0,1,1.04-.52h33.521a14.227,14.227,0,0,0,7.431-2.084Z",
    transform: "translate(-19.565 -155.32)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_19716",
    "data-name": "Path 19716",
    d: "M74.44,82.611a7.392,7.392,0,0,0,9.436,0l57.51-47.727a14.263,14.263,0,0,0-9.923-4.012H26.829a14.263,14.263,0,0,0-9.912,4Z",
    transform: "translate(-12.514)",
    fill: "#fff"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDebtSmsEmail);
export default __webpack_public_path__ + "static/media/Debt-SMS - Email.fb3ea8487d31233aecf0289619ee6baf.svg";
export { ForwardRef as ReactComponent };